import { Box, Flex, FormControl, FormLabel, Input, Button, InputGroup, InputLeftElement, FormErrorMessage } from '@chakra-ui/react'
import { SearchIcon } from '@chakra-ui/icons'
import { useForm } from 'react-hook-form'

export function FormularioPesquisa({ onSubmit, isLoading }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      codigo_produto: '',
    },
  })

  return (
    <Box
      as="form"
      onSubmit={handleSubmit(onSubmit)}
      p={4}
      bg="#F9F9F9"
      borderRadius="8px"
      boxShadow="sm"
      width="100%"
      maxWidth="800px"
      mx="auto"
      mb={6}
    >
      <Flex direction={{ base: 'column', md: 'row' }} gap={4} alignItems="flex-end">
        <FormControl isInvalid={!!errors.codigo_produto} isRequired flexGrow={1}>
          <FormLabel fontSize="sm" fontWeight="medium" color="#313E44">
            Código do Produto
          </FormLabel>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.400" />
            </InputLeftElement>
            <Input
              {...register('codigo_produto', {
                required: 'Este campo é obrigatório',
              })}
              placeholder="Digite o código do produto"
              focusBorderColor="#378BBF"
              borderRadius="md"
            />
          </InputGroup>
          <FormErrorMessage>{errors.codigo_produto?.message}</FormErrorMessage>
        </FormControl>

        <Button
          type="submit"
          leftIcon={<SearchIcon />}
          colorScheme="blue"
          bg="#378BBF"
          fontSize="sm"
          px={6}
          py={2}
          h="40px"
          borderRadius="8px"
          isLoading={isLoading}
          loadingText="Pesquisando..."
        >
          Pesquisar
        </Button>
      </Flex>
    </Box>
  )
}
